module.exports = __webpack_public_path__ + "img/organigram-download.d574a499.svg";